export enum EShiftSituationDirection {
    IN = 'in',
    OUT = 'out'
}
